import { resolveUrl } from "~/utils/url/urlResolver";
import { getCsrfValue } from "~/api/ApiHelper";

const url = resolveUrl("/cad/updateConfig");

export async function fetchUpdateConfiguration({
  partId,
  selectionPath,
  symbol,
  value,
}: {
  partId: string;
  selectionPath: string;
  symbol: string;
  value: string;
}) {
  const response = await fetch(url, {
    body: JSON.stringify({ partId, selectionPath, symbol, value }),
    credentials: "same-origin", // include, omit
    mode: "cors", // no-cors, same-origin
    referrer: "no-referrer", // client
    method: "POST",
    headers: {
      "content-type": "application/json",
      CSRFToken: getCsrfValue(),
    },
  });

  return response.json();
}
